import { axiosInstance } from './api';

export type DataCollection = {
  id: number; name: string; description: string; domain: 'table' | 'shelf';
  source: string; source_ref: string; status: string; error: string;
  total: number; ai: number; human: number; unlabelled: number; url: string;
};
export const getCollections = (domain: string) => axiosInstance.get<{ collections: DataCollection[] }>(
  '/ml_models_lifecycle/collections/', { params: { domain } });
export const getCollection = (id: string) => axiosInstance.get<DataCollection>(`/ml_models_lifecycle/collections/${id}/`);
export const unlinkCollection = (id: string, ids: number[]) => axiosInstance.post(
  `/ml_models_lifecycle/collections/${id}/members/`, { action: 'remove', ids });
